import { render } from "./SpreadsheetCopy.vue?vue&type=template&id=ff55fca8&bindings={\"initialValues\":\"setup\",\"validationSchema\":\"setup\",\"starterTemplateSpreadsheetId\":\"options\",\"submit\":\"options\"}"
import script from "./SpreadsheetCopy.vue?vue&type=script&lang=js"
export * from "./SpreadsheetCopy.vue?vue&type=script&lang=js"
script.render = render

export default script